import React from 'react';

const CountBox = ({ title, count, color, icon }: Props) => {
  return (
    <div className="d-flex flex-column count-box">
      <div>
        <p className="mb-0"><small>{title}</small></p>
      </div>
      <div className="d-flex align-items-center">
        <span className="avatar me-2">
          <span className={`avatar-initial rounded ${color}`}>
            <i className={`ti ti-md ${icon}`}></i>
          </span>
        </span>
        <h1 className="m-0">{count}</h1>
      </div>
    </div>
  );
}

interface Props {
  title: string,
  count: number,
  color: string,
  icon: string
}

export { CountBox };